module.exports = __webpack_public_path__ + "img/qd_05.8942564d.png";